document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.faq')) {
		const faqs = Array.from(document.querySelectorAll('.faq'));
		faqs.forEach((faq) => {
			const header = faq.querySelector('.header');
			const content = faq.querySelector('.content');
			header.addEventListener('click', () => {
				faq.classList.toggle('active');
				if (faq.classList.contains('active')) {
					content.style.height = `${content.firstElementChild.clientHeight}px`;
				} else {
					content.style.height = '0px';
				}
			});
		});

		window.addEventListener('resize', () => {
			faqs.forEach((faq) => {
				const content = faq.querySelector('.content');
				if (faq.classList.contains('active')) {
					content.style.height = `${content.firstElementChild.clientHeight}px`;
				}
			});
		});
	}
});
